import { MutationCache, QueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { ApiError } from './http';

/**
 * Query defaults: no retry for 4xx (business errors are final), up to 2 retries for network/5xx.
 * Mutations show a toast on failure unless they set `meta: { silent: true }` (forms that map field errors inline).
 */
export function createQueryClient() {
  return new QueryClient({
    queryCache: undefined,
    mutationCache: new MutationCache({
      onError: (error, _vars, _ctx, mutation) => {
        if (mutation.meta?.silent) return;
        if (error instanceof ApiError && (error.isValidation || error.isConflict)) return; // shown inline
        toast.error(error instanceof ApiError ? error.detail : 'Thao tác không thành công.', {
          description: error instanceof ApiError && error.traceId ? `Mã lỗi ${error.errorCode} · trace ${error.traceId}` : undefined,
        });
      },
    }),
    defaultOptions: {
      queries: {
        staleTime: 15_000,
        refetchOnWindowFocus: false,
        retry: (count, error) => {
          if (error instanceof ApiError && error.status >= 400 && error.status < 500) return false;
          return count < 2;
        },
      },
      mutations: { retry: false },
    },
  });
}

declare module '@tanstack/react-query' {
  interface Register {
    mutationMeta: { silent?: boolean };
  }
}
